import { Component, OnInit, Input, DoCheck, Optional, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, AsyncValidatorFn, ControlContainer, FormGroupDirective } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { MultiLingualTextBoxOptions } from '../../Shared/Models/MultilingualTextBoxOptions';
import { InputType } from '../../Shared/Enums/InputType';
import { UtilityService } from '../../Shared/services/UtilityService';
import { EnglishArabicDTO } from '../../Shared/Models/EnglishArabicDTO';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { LanguageMode } from '../../Shared/Enums/LanguageMode';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';


@Component({
  selector: 'BBSF-MultiLingualTextBox',
  templateUrl: './MultiLingualTextBox.component.html',
  styleUrls: ['./MultiLingualTextBox.component.scss']
})
export class MultiLingualTextBoxComponent implements OnInit {

  static controlContainerstatic = null;

  constructor(private ErrorHandler: ErrorMassageValidation, public MultiLingualTextBoxFormControlHost: FormGroupDirective, @Optional() private controlContainer: ControlContainer, private controlUtility: ControlUtility
  ) {
    MultiLingualTextBoxComponent.controlContainerstatic = this.controlContainer;
    this.CurrentLanguage = UtilityService.Translator.currentLang != undefined ? UtilityService.Translator.currentLang : UtilityService.Translator.defaultLang
  }
  @Input() group: FormGroup;
  @Input() options: MultiLingualTextBoxOptions;
  @Output() OnChange = new EventEmitter();

  ArabicFormControl: AbstractControl;
  EnglishFormControl: AbstractControl;
  MultiFormControl: AbstractControl;
  MultiLanguagegroup: FormGroup;
  ArabicWordCount: number = 0;
  ArabicWordCountArray: number = 0;
  EnglishWordCount: number = 0;
  EnglishWordCountArray: number = 0;
  CurrentLanguage: string = "";
  ShowArabicTextBox: boolean
  ShowEngishTextBox: boolean
  ArabicValidationRules = [];
  ArabicValidationRulesasync = [];
  EnglishValidationRules = [];
  EnglishValidationRulesasync = [];

  IsShowArabicWordCount: boolean = false;
  IsShowEnglishWordCount: boolean = false;
  markAllAsTouched: boolean = false;




  ngOnInit() {
    UtilityService.isCreatedBefor = false
    this.CurrentLanguage = UtilityService.CurrentLanguage;

    UtilityService.Translator.onLangChange.subscribe((event: LangChangeEvent) => {
      this.CurrentLanguage = event.lang;
      this.showInputUsingLanguageMode()
    });
    this.MultiLanguagegroup = new FormGroup({});;
    this.MultiLanguagegroup.addControl("ArabicValue", new FormControl(''));
    this.MultiLanguagegroup.addControl("EnglishValue", new FormControl(''));
    this.ArabicFormControl = this.MultiLanguagegroup.controls["ArabicValue"]; //  new FormControl('',validationRules);
    this.EnglishFormControl = this.MultiLanguagegroup.controls["EnglishValue"]; //  new FormControl('',validationRules);
    this.group.addControl(this.options.Name, new FormGroup(this.MultiLanguagegroup.controls));

    if (this.options.ArabicLabelKey != null && this.options.ArabicLabelKey != "")
      this.options.ArabicLabelValue = UtilityService.getResourceValue(this.options.ArabicLabelKey);

    if (this.options.EnglishLabelKey != null && this.options.EnglishLabelKey != "")
      this.options.EnglishLabelValue = UtilityService.getResourceValue(this.options.EnglishLabelKey);

    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.EnglishValidationRules.push(Validation.functionBody);
        this.ArabicValidationRules.push(Validation.functionBody);
      }

    }
    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.EnglishValidationRules.push(Validation.functionBody);
        this.ArabicValidationRules.push(Validation.functionBody);
      }

    }
    if (this.options.MinLength > 0) {
      this.ArabicValidationRules.push(Validators.minLength(this.options.MinLength));
      this.EnglishValidationRules.push(Validators.minLength(this.options.MinLength));

    }

    if (this.options.MaxLength > 0) {
      this.EnglishValidationRules.push(Validators.maxLength(this.options.MaxLength));
      this.ArabicValidationRules.push(Validators.maxLength(this.options.MaxLength));

    }

    this.showInputUsingLanguageMode();
    this.ArabicFormControl.setValidators(this.ArabicValidationRules);
    this.ArabicFormControl.setAsyncValidators(this.ArabicValidationRulesasync);
    this.EnglishFormControl.setValidators(this.EnglishValidationRules);
    this.EnglishFormControl.setAsyncValidators(this.EnglishValidationRulesasync);
    if (this.options.IsDisabled) {
      this.EnglishFormControl.disable();
      this.ArabicFormControl.disable();
    }
    this.ArabicFormControl.setValue(this.options.Value.Arabic)
    this.EnglishFormControl.setValue(this.options.Value.English)

    this.MultiLingualTextBoxFormControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })
  }


  onTextChange() {
    let arabicValue = this.MultiLanguagegroup.controls["ArabicValue"].value == null ? "" : this.MultiLanguagegroup.controls["ArabicValue"].value;
    let englishValue = this.MultiLanguagegroup.controls["EnglishValue"].value == null ? "" : this.MultiLanguagegroup.controls["EnglishValue"].value;
    if (this.EnglishFormControl.value == "") {
      this.EnglishWordCountArray = 0;
      this.EnglishWordCount = 0;
    }
    else {
      if (this.EnglishFormControl.value != null || this.EnglishFormControl.value != undefined) {
        this.EnglishWordCountArray = this.EnglishFormControl.value.split(" ").length;
        if (this.EnglishWordCountArray > 0) {
          if (this.EnglishWordCountArray > this.options.MaxWordCount) {
            this.EnglishWordCount = this.options.MaxWordCount;
            this.MultiLanguagegroup.controls["EnglishValue"].setErrors({ MaxWordCountValidationKey: this.options.MaxWordCount });
            this.MultiLanguagegroup.controls["EnglishValue"].markAsTouched();
            this.MultiLanguagegroup.controls["EnglishValue"].invalid;
          }
          else {
            this.EnglishWordCount = this.EnglishWordCountArray;
          }
        }
      }

    }
    if (this.ArabicFormControl.value == "") {
      this.ArabicWordCountArray = 0;
      this.ArabicWordCount = 0;
    }
    else {
      if (this.ArabicFormControl.value != null || this.ArabicFormControl.value != undefined) {
        this.ArabicWordCountArray = this.ArabicFormControl.value.split(" ").length;
        if (this.ArabicWordCountArray > 0) {
          if (this.ArabicWordCountArray > this.options.MaxWordCount) {
            this.ArabicWordCount = this.options.MaxWordCount;
            this.MultiLanguagegroup.controls["ArabicValue"].setErrors({ MaxWordCountValidationKey: this.options.MaxWordCount });
            this.MultiLanguagegroup.controls["ArabicValue"].markAsTouched();
            this.MultiLanguagegroup.controls["ArabicValue"].invalid;
          }
          else {
            this.ArabicWordCount = this.ArabicWordCountArray;
          }
        }
      }

    }
    let mulitLangModel = new EnglishArabicDTO();
    mulitLangModel.Arabic = arabicValue;
    mulitLangModel.English = englishValue;
    this.ArabicFormControl = arabicValue;
    this.EnglishFormControl = englishValue;
    this.OnChange.emit(mulitLangModel)
    this.group.get(this.options.Name).setValue(mulitLangModel);

    this.MultiLingualTextBoxFormControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })


  }



  resetError() {
    UtilityService.RemoveGlobalError();
  }
  //External Method
  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.ArabicFormControl, this.EnglishValidationRules, this.options)
    this.controlUtility.RemoveRequiredValidation(this.EnglishFormControl, this.ArabicValidationRules, this.options)
  }
  //External Method
  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.ArabicFormControl, this.EnglishValidationRules, this.options)
    this.controlUtility.AddRequiredValidation(this.EnglishFormControl, this.ArabicValidationRules, this.options)
  }

  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.ArabicFormControl, this.EnglishValidationRules, CustomValidation)
    this.controlUtility.RemoveCustomValidation(this.EnglishFormControl, this.ArabicValidationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.ArabicFormControl, this.EnglishValidationRules, CustomValidation)
    this.controlUtility.AddCustomValidation(this.EnglishFormControl, this.ArabicValidationRules, CustomValidation)
  }

  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.ArabicFormControl)
    this.controlUtility.IsValid(this.EnglishFormControl)
  }

  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }
    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }


  getInputType(type: number) {
    return InputType[type]
  }

  trimControlValue(type: string) {
    const whitespace: string = ' ';
    if (type == "En") {
      if (this.EnglishFormControl.value.startsWith(whitespace) || this.EnglishFormControl.value.endsWith(whitespace)) {
        this.EnglishFormControl.patchValue(this.EnglishFormControl.value.trim());
      }
    }
    if (type == "Ar") {
      if (this.ArabicFormControl.value.startsWith(whitespace) || this.ArabicFormControl.value.endsWith(whitespace)) {
        this.ArabicFormControl.patchValue(this.ArabicFormControl.value.trim());

      }
    }

  }

  copyInputMessage(inputElement) {
    this.controlUtility.CopyInputMessage(inputElement)
  }

  showInputUsingLanguageMode() {
    this.ArabicValidationRules = this.ArabicValidationRules.filter(item => item !== Validators.required);
    this.EnglishValidationRules = this.EnglishValidationRules.filter(item => item !== Validators.required);

    this.ArabicFormControl.clearValidators();
    this.EnglishFormControl.clearValidators();

    this.ArabicFormControl.updateValueAndValidity();
    this.EnglishFormControl.updateValueAndValidity();

    switch (this.options.LanguageMode) {
      case LanguageMode.Both_Languages_are_visible:
        this.ShowArabicTextBox = true;
        this.ShowEngishTextBox = true;
        if (this.options.IsRequired == true) {
          this.EnglishValidationRules.push(Validators.required);
          this.ArabicValidationRules.push(Validators.required);


        }
        break;
      case LanguageMode.Arabic_Language_only_is_visible:
        this.ShowArabicTextBox = true;
        break;
      case LanguageMode.English_Language_only_is_visible:
        this.ShowEngishTextBox = true;
        break;
      case LanguageMode.Both_Languages_are_visible_but_only_current_language_is_required:
        this.ShowArabicTextBox = true;
        this.ShowEngishTextBox = true;

        if (this.CurrentLanguage == 'ar') {
          if (this.options.IsRequired == true) {
            this.ArabicValidationRules.push(Validators.required);

          }
        }
        if (this.CurrentLanguage == 'en') {
          if (this.options.IsRequired == true) {
            this.EnglishValidationRules.push(Validators.required);


          }
        }
        break;
      case LanguageMode.Both_Languages_but_only_Arabic_is_required:
        this.ShowArabicTextBox = true;
        this.ShowEngishTextBox = true;
        if (this.options.IsRequired == true) {
          this.ArabicValidationRules.push(Validators.required);

        }
        break;
      case LanguageMode.Both_Languages_but_only_English_is_required:
        this.ShowArabicTextBox = true;
        this.ShowEngishTextBox = true;
        if (this.options.IsRequired == true) {
          this.EnglishValidationRules.push(Validators.required);

        }
        break;
      case LanguageMode.Current_Language_only_is_visible_and_required:
        if (this.CurrentLanguage == 'ar') {
          this.ShowArabicTextBox = true;
          this.ShowEngishTextBox = false;

          if (this.options.IsRequired == true) {
            this.ArabicValidationRules.push(Validators.required);

          }
        }
        if (this.CurrentLanguage == 'en') {
          this.ShowArabicTextBox = false;
          this.ShowEngishTextBox = true;
          if (this.options.IsRequired == true) {
            this.EnglishValidationRules.push(Validators.required);

          }
        }
        break;
      default:
        break;
    }

    this.ArabicFormControl.setValidators(this.ArabicValidationRules);
    this.EnglishFormControl.setValidators(this.EnglishValidationRules);
    this.ArabicFormControl.updateValueAndValidity();
    this.EnglishFormControl.updateValueAndValidity();

  }

  showArabicWordCount(value: boolean) {
    this.IsShowArabicWordCount = value
  }

  showEnglishWordCount(value: boolean) {
    this.IsShowEnglishWordCount = value
  }


}

